import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { Formik, Form } from 'formik'
import { toast } from 'react-toastify'
import { Button, Modal, InputGroup, FormControl } from 'react-bootstrap'

import locationApi from '../../utils/locationApi'
import config from '../../config'

const url = config.api.baseUrl + '/branches'

const AddBranchModal = (props) => {
  const { show, onClose } = props

  const handleSubmit = useCallback(
    async (data, { resetForm }) => {
      try {
        await locationApi('post', url, data)
        onClose()
        resetForm()
        toast('Succesfully added.', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2500
        })
      } catch (err) {
        onClose()
        toast.error(`${err}`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2500
        })
        console.log(err)
      }
    }, [onClose])

  return (
    <>
      <Formik
        initialValues={{
          name: '',
          description: ''
        }}
        onSubmit={handleSubmit}
      >{
          ({ values, handleChange, handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <Modal show={show} onHide={onClose}>
                <Modal.Header closeButton>
                  <Modal.Title>Branch</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <InputGroup className='mb-3'>
                    <InputGroup.Prepend>
                      <InputGroup.Text>ID</InputGroup.Text>
                    </InputGroup.Prepend>
                    <FormControl
                      name='name'
                      value={values.name}
                      onChange={handleChange}
                    />
                  </InputGroup>
                  <InputGroup className='mb-3'>
                    <InputGroup.Prepend>
                      <InputGroup.Text>Description</InputGroup.Text>
                    </InputGroup.Prepend>
                    <FormControl
                      name='description'
                      value={values.description}
                      onChange={handleChange}
                    />
                  </InputGroup>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    disabled={!values.name || !values.description}
                    onClick={handleSubmit}
                    type='submit'
                  >
                    Add Branch
                  </Button>
                </Modal.Footer>
              </Modal>
            </Form>
          )
        }
      </Formik>
    </>
  )
}

export default AddBranchModal

AddBranchModal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func
}
